export const FORMS: any[] = [
    {
        "name" : "AddContentAssoc",
        "altTarget" : [ ],
        "formLocation" : "component://content/widget/content/ContentForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "contentId",
            "action" : "",
            "id" : "AddContentAssoc_contentId",
            "type" : "display",
            "event" : "",
            "value" : "",
            "title" : "Content Id"
        }, {
            "conditionGroup" : "",
            "name" : "createdDate",
            "action" : "",
            "id" : "AddContentAssoc_createdDate",
            "type" : "hidden",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "createdByUserLogin",
            "action" : "",
            "id" : "AddContentAssoc_createdByUserLogin",
            "type" : "hidden",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "lastModifiedDate",
            "action" : "",
            "id" : "AddContentAssoc_lastModifiedDate",
            "type" : "hidden",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "lastModifiedByUserLogin",
            "action" : "",
            "id" : "AddContentAssoc_lastModifiedByUserLogin",
            "type" : "hidden",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contentId",
            "description" : "",
            "style" : "",
            "id" : "AddContentAssoc_contentId",
            "title" : "",
            "type" : "display",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required",
            "type" : "lookup",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddContentAssoc",
            "id" : "AddContentAssoc_contentIdTo",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupContent",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "",
            "tabindex" : "",
            "size" : "25",
            "name" : "contentIdTo",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "contentIdTo",
            "style" : "",
            "id" : "AddContentAssoc_contentIdTo",
            "title" : "Content Id To",
            "type" : "lookup"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "required",
            "title" : "Content Assoc Type ID",
            "type" : "dropdown",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddContentAssoc",
            "allOptionValues" : [ {
            "description" : "Alternate Locale",
            "key" : "ALTERNATE_LOCALE"
            }, {
            "description" : "Alternate Role",
            "key" : "ALTERNATE_ROLE"
            }, {
            "description" : "Alternative URL",
            "key" : "ALTERNATIVE_URL"
            }, {
            "description" : "Attribute",
            "key" : "ATTRIBUTE"
            }, {
            "description" : "Author",
            "key" : "AUTHOR"
            }, {
            "description" : "Department",
            "key" : "DEPARTMENT"
            }, {
            "description" : "Description",
            "key" : "DESCRIPTION"
            }, {
            "description" : "Document Structure Definition",
            "key" : "STRUCTURE_DEF"
            }, {
            "description" : "Graph Link",
            "key" : "GRAPH_LINK"
            }, {
            "description" : "Image Thumbnail",
            "key" : "IMAGE_THUMBNAIL"
            }, {
            "description" : "Instance Of",
            "key" : "INSTANCE"
            }, {
            "description" : "List Entry",
            "key" : "LIST_ENTRY"
            }, {
            "description" : "Publish link",
            "key" : "PUBLISH_LINK"
            }, {
            "description" : "Related content",
            "key" : "RELATED_CONTENT"
            }, {
            "description" : "Response",
            "key" : "RESPONSE"
            }, {
            "description" : "Sub Section",
            "key" : "SUB_CONTENT"
            }, {
            "description" : "SubSite",
            "key" : "SUBSITE"
            }, {
            "description" : "Summary",
            "key" : "SUMMARY"
            }, {
            "description" : "Template Member",
            "key" : "TEMPLATE_MEMBER"
            }, {
            "description" : "Topic",
            "key" : "TOPIC"
            }, {
            "description" : "Transformation Definition",
            "key" : "TXFORM_DEF"
            }, {
            "description" : "Tree Child",
            "key" : "TREE_CHILD"
            } ],
            "disabled" : "false",
            "id" : "AddContentAssoc_contentAssocTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "contentAssocTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "datetime",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddContentAssoc",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddContentAssoc_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Thru Date",
            "type" : "datetime",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2022-10-08%2014:07:51.582",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddContentAssoc",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddContentAssoc_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Content Assoc Predicate ID",
            "type" : "text",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "contentAssocPredicateId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddContentAssoc_contentAssocPredicateId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Data Source ID",
            "type" : "text",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "dataSourceId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddContentAssoc_dataSourceId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "text",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddContentAssoc_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "60",
            "tabindex" : "",
            "className" : "",
            "title" : "Map Key",
            "type" : "text",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "mapKey",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddContentAssoc_mapKey",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Upper Coordinate",
            "type" : "text",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "upperCoordinate",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddContentAssoc_upperCoordinate",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Left Coordinate",
            "type" : "text",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "leftCoordinate",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "AddContentAssoc_leftCoordinate",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Meta Data Predicate ID",
            "type" : "dropdown",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddContentAssoc",
            "allOptionValues" : [ {
            "description" : "Name of the author or creator of the subject.",
            "key" : "author-name"
            }, {
            "description" : "eMail address of the author or creator of the subject.",
            "key" : "author-email"
            }, {
            "description" : "The date and time the subject event took place, preferably in the descending standard format: [yyyy-MM-dd hh:mm:ss].",
            "key" : "event-date"
            }, {
            "description" : "The location where subject event took place.",
            "key" : "event-location"
            }, {
            "description" : "The name of a person involved in the subject event.",
            "key" : "event-person-name"
            } ],
            "disabled" : "false",
            "id" : "AddContentAssoc_metaDataPredicateId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "metaDataPredicateId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddContentAssoc",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddContentAssoc_submitButton",
            "confirmation" : "",
            "type" : "submit",
            "title" : "",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createContentAssoc"
        },

    {
        "columns" : [ {
            "name" : "contentIdTo",
            "title" : "Content Id To"
        }, {
            "name" : "contentAssocTypeId",
            "title" : "Content Assoc Type ID"
        }, {
            "name" : "mapKey",
            "title" : "Map Key"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "deleteLink",
            "title" : " "
        }, {
            "name" : "thruDate",
            "title" : "Thru Date"
        }, {
            "name" : "updateButton",
            "title" : ""
        } ],
        "name" : "ListContentAssocFromRest",
        "altTarget" : [ ],
        "formLocation" : "component://content/widget/content/ContentForms.xml",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "contentId",
            "action" : "",
            "id" : "ListContentAssocFrom_contentId",
            "type" : "hidden",
            "event" : "",
            "value" : ""
        }, {
            "hyperlink" : {
            "linkStyle" : "",
            "description" : "",
            "targetType" : "intra-app",
            "confirmation" : "",
            "parameterMap" : {
                "VIEW_SIZE_0" : "20",
                "VIEW_INDEX_0" : "0"
            },
            "uniqueItemName" : "Modal_5200a499_d571_4070_8b0c_dfcb88961b6a",
            "target" : "EditContentAssoc",
            "targetWindow" : ""
            },
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contentIdTo",
            "description" : "",
            "style" : "",
            "id" : "ListContentAssocFrom_contentIdTo",
            "title" : "Content Id To",
            "type" : "display-entity",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contentAssocTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListContentAssocFrom_contentAssocTypeId",
            "title" : "Content Assoc Type ID",
            "type" : "display-entity",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "mapKey",
            "description" : "",
            "style" : "",
            "id" : "ListContentAssocFrom_mapKey",
            "title" : "Map Key",
            "type" : "display",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListContentAssocFrom_fromDate",
            "title" : "From Date",
            "type" : "display",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "contentId"
            }, {
            "name" : "contentIdTo"
            }, {
            "name" : "contentAssocTypeId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "ListContentAssocFrom_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Thru Date",
            "type" : "datetime",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2022-10-08%2013:29:50.6",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ListContentAssocFrom",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "ListContentAssocFrom_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "buttonType" : "text-link",
            "alert" : "false",
            "formName" : "ListContentAssocFrom",
            "tabindex" : "",
            "name" : "updateButton",
            "className" : "buttontext",
            "id" : "ListContentAssocFrom_updateButton",
            "confirmation" : "",
            "type" : "submit",
            "title" : "",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateContentAssoc"
    },
    {
        "name" : "AddContentRole",
        "altTarget" : [ ],
        "formLocation" : "component://content/widget/content/ContentForms.xml",
        "fields" : [ {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required buttontext",
            "type" : "lookup",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddContentRole",
            "id" : "AddContentRole_contentId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupContent",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "",
            "tabindex" : "",
            "size" : "25",
            "name" : "contentId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "contentId",
            "style" : "",
            "id" : "AddContentRole_contentId",
            "title" : "Content ID",
            "type" : "lookup"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "required buttontext",
            "type" : "lookup",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "AddContentRole",
            "id" : "AddContentRole_partyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPerson",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "",
            "tabindex" : "",
            "size" : "25",
            "name" : "partyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "partyId",
            "style" : "",
            "id" : "AddContentRole_partyId",
            "title" : "Party ID",
            "type" : "lookup"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "required",
            "title" : "Role Type ID",
            "type" : "dropdown",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "AddContentRole",
            "allOptionValues" : [ {
            "description" : "Account",
            "key" : "ACCOUNT"
            }, {
            "description" : "Account Lead",
            "key" : "ACCOUNT_LEAD"
            }, {
            "description" : "Accountant",
            "key" : "ACCOUNTANT"
            }, {
            "description" : "Addressee",
            "key" : "ADDRESSEE"
            }, {
            "description" : "Administrator",
            "key" : "ADMIN"
            }, {
            "description" : "Affiliate",
            "key" : "AFFILIATE"
            }, {
            "description" : "Agent",
            "key" : "AGENT"
            }, {
            "description" : "Approver",
            "key" : "APPROVER"
            }, {
            "description" : "Association",
            "key" : "ASSOCIATION"
            }, {
            "description" : "Automated Agent",
            "key" : "AUTOMATED_AGENT_ROLE"
            }, {
            "description" : "Bill-From-Vendor",
            "key" : "BILL_FROM_VENDOR"
            }, {
            "description" : "Bill-To Customer",
            "key" : "BILL_TO_CUSTOMER"
            }, {
            "description" : "Blind Copy",
            "key" : "BCC"
            }, {
            "description" : "Budget Application",
            "key" : "BUDGET_APPL"
            }, {
            "description" : "Budget Approver",
            "key" : "BUDGET_APPRV"
            }, {
            "description" : "Budget Manager",
            "key" : "BUDGET_MGR"
            }, {
            "description" : "Budget Reviewer",
            "key" : "BUDGET_RVR"
            }, {
            "description" : "Budget Roles Group (not to be assigned to parties)",
            "key" : "BUDGET"
            }, {
            "description" : "Bulk Customer",
            "key" : "BULK_CUSTOMER"
            }, {
            "description" : "Buyer",
            "key" : "BUYER"
            }, {
            "description" : "Calendar",
            "key" : "CALENDAR_ROLE"
            }, {
            "description" : "Calendar Attendee",
            "key" : "CAL_ATTENDEE"
            }, {
            "description" : "Calendar Delegate",
            "key" : "CAL_DELEGATE"
            }, {
            "description" : "Calendar Host",
            "key" : "CAL_HOST"
            }, {
            "description" : "Calendar Member",
            "key" : "ICAL_MEMBER"
            }, {
            "description" : "Calendar Organizer",
            "key" : "CAL_ORGANIZER"
            }, {
            "description" : "Calendar Owner",
            "key" : "CAL_OWNER"
            }, {
            "description" : "Carbon Copy",
            "key" : "CC"
            }, {
            "description" : "Carrier",
            "key" : "CARRIER"
            }, {
            "description" : "Cashier",
            "key" : "CASHIER"
            }, {
            "description" : "Client",
            "key" : "CLIENT"
            }, {
            "description" : "Client Analyst",
            "key" : "CLIENT_ANALYST"
            }, {
            "description" : "Client Billing",
            "key" : "CLIENT_BILLING"
            }, {
            "description" : "Client Manager",
            "key" : "CLIENT_MANAGER"
            }, {
            "description" : "Communication Participant",
            "key" : "COMMEVENT_ROLE"
            }, {
            "description" : "Competitor",
            "key" : "COMPETITOR"
            }, {
            "description" : "Consumer",
            "key" : "CONSUMER"
            }, {
            "description" : "Contact",
            "key" : "CONTACT"
            }, {
            "description" : "Content Administrator",
            "key" : "CONTENT_ADMIN"
            }, {
            "description" : "Content Author",
            "key" : "CONTENT_AUTHOR"
            }, {
            "description" : "Content Editor",
            "key" : "CONTENT_EDITOR"
            }, {
            "description" : "Content Guest",
            "key" : "CONTENT_GUEST"
            }, {
            "description" : "Content Member",
            "key" : "CONTENT"
            }, {
            "description" : "Content Publisher",
            "key" : "CONTENT_PUBLISHER"
            }, {
            "description" : "Content User",
            "key" : "CONTENT_USER"
            }, {
            "description" : "Contractor",
            "key" : "CONTRACTOR"
            }, {
            "description" : "Customer",
            "key" : "CUSTOMER"
            }, {
            "description" : "Department",
            "key" : "DEPARTMENT"
            }, {
            "description" : "Distribution Channel",
            "key" : "DISTRIBUTION_CHANNEL"
            }, {
            "description" : "Distributor",
            "key" : "DISTRIBUTOR"
            }, {
            "description" : "Division",
            "key" : "DIVISION"
            }, {
            "description" : "Email Administrator",
            "key" : "EMAIL_ADMIN"
            }, {
            "description" : "Employee",
            "key" : "EMPLOYEE"
            }, {
            "description" : "Employer",
            "key" : "EMPLOYER"
            }, {
            "description" : "End-User Customer",
            "key" : "END_USER_CUSTOMER"
            }, {
            "description" : "Family Member",
            "key" : "FAMILY_MEMBER"
            }, {
            "description" : "Fixed Asset Maint Assignee",
            "key" : "FAM_ASSIGNEE"
            }, {
            "description" : "Government Agency",
            "key" : "GOV_AGENCY"
            }, {
            "description" : "Hosting Server",
            "key" : "HOSTING_SERVER"
            }, {
            "description" : "Household",
            "key" : "HOUSEHOLD"
            }, {
            "description" : "ISP",
            "key" : "ISP"
            }, {
            "description" : "Image Approver",
            "key" : "IMAGEAPPROVER"
            }, {
            "description" : "Internal Organization",
            "key" : "INTERNAL_ORGANIZATIO"
            }, {
            "description" : "Lead",
            "key" : "LEAD"
            }, {
            "description" : "Limited Administrator",
            "key" : "LTD_ADMIN"
            }, {
            "description" : "Logged In",
            "key" : "LOGGEDIN"
            }, {
            "description" : "Main Role",
            "key" : "MAIN_ROLE"
            }, {
            "description" : "Maintenance Manager or Supervisor",
            "key" : "FAM_MANAGER"
            }, {
            "description" : "Maintenance Supplier or Service",
            "key" : "FAM_SUPPLIER"
            }, {
            "description" : "Maintenance Worker",
            "key" : "FAM_WORKER"
            }, {
            "description" : "Manager",
            "key" : "MANAGER"
            }, {
            "description" : "Manufacturer",
            "key" : "MANUFACTURER"
            }, {
            "description" : "Not Applicable",
            "key" : "_NA_"
            }, {
            "description" : "Order Clerk",
            "key" : "ORDER_CLERK"
            }, {
            "description" : "Organization",
            "key" : "ORGANIZATION_ROLE"
            }, {
            "description" : "Organization Unit",
            "key" : "ORGANIZATION_UNIT"
            }, {
            "description" : "Originator",
            "key" : "ORIGINATOR"
            }, {
            "description" : "Other Internal",
            "key" : "OTHER_INTERNAL_ORGAN"
            }, {
            "description" : "Other Organization Unit",
            "key" : "OTHER_ORGANIZATION_U"
            }, {
            "description" : "Owner",
            "key" : "OWNER"
            }, {
            "description" : "Packer",
            "key" : "PACKER"
            }, {
            "description" : "Parent Organization",
            "key" : "PARENT_ORGANIZATION"
            }, {
            "description" : "Partner",
            "key" : "PARTNER"
            }, {
            "description" : "Person",
            "key" : "PERSON_ROLE"
            }, {
            "description" : "Picker",
            "key" : "PICKER"
            }, {
            "description" : "Placing Customer",
            "key" : "PLACING_CUSTOMER"
            }, {
            "description" : "Product Owner",
            "key" : "PRODUCT_OWNER"
            }, {
            "description" : "Product Owner Company",
            "key" : "PRODUCT_OWNER_COMP"
            }, {
            "description" : "Project Team",
            "key" : "PROJECT_TEAM"
            }, {
            "description" : "Prospect",
            "key" : "PROSPECT"
            }, {
            "description" : "Provider Accounting",
            "key" : "PROVIDER_ACCOUNTING"
            }, {
            "description" : "Provider Analyst",
            "key" : "PROVIDER_ANALYST"
            }, {
            "description" : "Provider Functional",
            "key" : "PROVIDER_FUNCTIONAL"
            }, {
            "description" : "Provider Manager",
            "key" : "PROVIDER_MANAGER"
            }, {
            "description" : "Provider Tester",
            "key" : "PROVIDER_TESTER"
            }, {
            "description" : "Provider Validator",
            "key" : "PROVIDER_VALIDATOR"
            }, {
            "description" : "Receiver",
            "key" : "RECEIVER"
            }, {
            "description" : "Referrer",
            "key" : "REFERRER"
            }, {
            "description" : "Regulatory Agency",
            "key" : "REGULATORY_AGENCY"
            }, {
            "description" : "Request Manager",
            "key" : "REQ_MANAGER"
            }, {
            "description" : "Request Respondent",
            "key" : "REQ_RESPOND"
            }, {
            "description" : "Request Role",
            "key" : "REQUEST_ROLE"
            }, {
            "description" : "Request Taker",
            "key" : "REQ_TAKER"
            }, {
            "description" : "Requesting Party",
            "key" : "REQ_REQUESTER"
            }, {
            "description" : "Reviewer",
            "key" : "REVIEWER"
            }, {
            "description" : "SCRUM Master",
            "key" : "SCRUM_MASTER"
            }, {
            "description" : "SCRUM Team",
            "key" : "SCRUM_TEAM"
            }, {
            "description" : "Sales Force Autm.",
            "key" : "SFA_ROLE"
            }, {
            "description" : "Sales Representative",
            "key" : "SALES_REP"
            }, {
            "description" : "Scrum Member",
            "key" : "SCRUM_MEMBER"
            }, {
            "description" : "Shareholder",
            "key" : "SHAREHOLDER"
            }, {
            "description" : "Ship-From Vendor",
            "key" : "SHIP_FROM_VENDOR"
            }, {
            "description" : "Ship-To Customer",
            "key" : "SHIP_TO_CUSTOMER"
            }, {
            "description" : "Shipment Clerk",
            "key" : "SHIPMENT_CLERK"
            }, {
            "description" : "Sponsor",
            "key" : "SPONSOR"
            }, {
            "description" : "Spouse",
            "key" : "SPOUSE"
            }, {
            "description" : "Stakeholder",
            "key" : "STAKEHOLDER"
            }, {
            "description" : "Stocker",
            "key" : "STOCKER"
            }, {
            "description" : "Subscriber",
            "key" : "SUBSCRIBER"
            }, {
            "description" : "Subsidiary",
            "key" : "SUBSIDIARY"
            }, {
            "description" : "Supplier",
            "key" : "SUPPLIER"
            }, {
            "description" : "Supplier Agent",
            "key" : "SUPPLIER_AGENT"
            }, {
            "description" : "Tax Authority",
            "key" : "TAX_AUTHORITY"
            }, {
            "description" : "Union",
            "key" : "UNION"
            }, {
            "description" : "Vendor",
            "key" : "VENDOR"
            }, {
            "description" : "Visitor",
            "key" : "VISITOR"
            }, {
            "description" : "Web Master",
            "key" : "WEB_MASTER"
            }, {
            "description" : "Worker",
            "key" : "WORKER"
            }, {
            "description" : "Workflow",
            "key" : "WORKFLOW_ROLE"
            }, {
            "description" : "Workflow Owner",
            "key" : "WF_OWNER"
            } ],
            "disabled" : "false",
            "id" : "AddContentRole_roleTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "roleTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "datetime",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddContentRole",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddContentRole_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Thru Date",
            "type" : "datetime",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2022-10-11%2012:42:02.119",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "AddContentRole",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "AddContentRole_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "AddContentRole",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "AddContentRole_submitButton",
            "confirmation" : "",
            "type" : "submit",
            "title" : "",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "addContentRole"
    },
    {
        "columns" : [ {
            "name" : "contentId",
            "title" : "Content ID"
        }, {
            "name" : "partyId",
            "title" : "Party ID"
        }, {
            "name" : "roleTypeId",
            "title" : "Role Type ID"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Thru Date"
        }, {
            "name" : "submitButton",
            "title" : ""
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "name" : "ListContentRole",
        "altTarget" : [ ],
        "formLocation" : "component://content/widget/content/ContentForms.xml",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contentId",
            "description" : "",
            "style" : "",
            "id" : "ListContentRole_contentId",
            "title" : "Content ID",
            "type" : "display",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "ListContentRole_partyId",
            "title" : "",
            "type" : "display",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "roleTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListContentRole_roleTypeId",
            "title" : "Role Type ID",
            "type" : "display",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListContentRole_fromDate",
            "title" : "From Date",
            "type" : "display",
            "imageLocation" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "buttontext",
            "title" : "Thru Date",
            "type" : "datetime",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2022-10-11%2012:49:58.19",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ListContentRole",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "ListContentRole_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "ListContentRole",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "ListContentRole_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "",
            "event" : "",
            "imgSrc" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "contentId"
            }, {
            "name" : "roleTypeId"
            }, {
            "name" : "partyId"
            }, {
            "name" : "fromDate"
            } ],
            "id" : "ListContentRole_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        } ],
        "target" : "update${contentRoleTarget}ContentRole"
    }


]